import { createReducer } from '@reduxjs/toolkit';
import initialFaqState from './state';
import type { FaqState } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

const FaqReducer = createReducer<FaqState>(initialFaqState, () => {});

export default FaqReducer;
